import { TranslationEntity } from "src/common/components";

// REVIEW: Fajl bi trebalo da bude u jednini role-action.model.ts, ime klase bi trebalo biti RoleActionModel

export class RoleActionModel {
  id: number;
  name: string;
  description: string;
  created: string;
  updated: string;
  createdOn: Date;
  updatedOn: Date;
  roleId: number;
  actionId: number;
}

export class RoleActionListSearchModel {
  items: RoleActionModel[];
  totalCount: number;
}

export class RoleActionSaveModel {
  roleId: number;
  actionIds: Array<number>;
  constructor(_id: number, _edit: Array<number>) {
    this.roleId = _id;
    this.actionIds = _edit;
  }
}

export class RoleActionDeleteModel {

  actionIds: Array<number>;
  constructor(_edit: Array<number>) {

    this.actionIds = _edit;
  }
}


